/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import { fbEvent } from "@rivercode/facebook-conversion-api-nextjs";
import Error from "components/Error";
import Loader from "components/Loader";
import { seriesLandingSlices } from "containers/SeriesLandingSlices";
import { seriesGalleryTab } from "containers/SeriesLandingSlices/GalleryTab";
import Models from "containers/SeriesLandingSlices/Models";
import { seriesOverviewTab } from "containers/SeriesLandingSlices/Overview";
import { seriesTechnicalTab } from "containers/SeriesLandingSlices/TechnicalTab";
import { seriesVideoTab } from "containers/SeriesLandingSlices/VideoTab";
import Prismic, { getDocumentByUid } from "helpers/Prismic";
import breakPoints from "helpers/Styles";
import { API } from "lib/arkade-graphql";
import Head from "next/head";
import { useRouter } from "next/router";
import { StorefrontContext } from "providers/storefront";
import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-scroll";
import { globalPropsRequests } from "utils/globalProps";
import TiktokPixel from 'tiktok-pixel';
import { v4 as uuidv4 } from 'uuid';
import FacebookPixel from 'components/FacebookPixel';

import {
  sendShopifyAnalytics,
  getClientBrowserParameters,
  AnalyticsEventName,
} from "@shopify/hydrogen-react";
import Script from "next/script";

const seriesLandingPage = ({ seriesContent, pcModels, modelsCardListData }) => {
  // console.log("seriesContent>>>", seriesContent);
  // console.log("pcModels>>>", pcModels);
  // console.log("modelsData>>>", modelsData);
  const { isFallback } = useRouter();
  if (isFallback) {
    return <Loader />;
  }
  if (!seriesContent) {
    return <Error code={404} />;
  }

  const backgroundColor = seriesContent?.background_color;
  const primaryFontColor = seriesContent?.primary_font_color;
  const secondaryFontColor = seriesContent?.secondary_font_color;

  // console.log("seriesContent PC", seriesContent.pc_models);
	const custom_build_pc_urls = seriesContent.pc_models?.map((prismicModel) => {
		return prismicModel.custom_build_pc_url?.url ?? null;
	})

	const pc_model_titles = seriesContent.pc_models?.map((prismicModel) => {
		return prismicModel.pc_model_title[0]?.text ?? null;
	})

	const pc_model_subtitles = seriesContent.pc_models?.map((prismicModel) => {
		return prismicModel.pc_model_subtitle[0]?.text ?? null;
	})

  // const arrangedPcModels = seriesContent.pc_models?.map((prismicModel) => {
  //   return pcModels.find(
  //     (item) => item.prismic_uid === prismicModel.pc_model.uid
  //   );
  // });

	const combinedArr = [];
	pcModels.forEach((pcModel, index) => {
			const combinedModel = { ...pcModel };
			combinedModel.custom_build_pc_url = custom_build_pc_urls[index];
			combinedModel.pc_model_title = pc_model_titles[index];
			combinedModel.pc_model_subtitle = pc_model_subtitles[index];
			combinedArr.push(combinedModel);
    });
    // console.log("Combined array>>>>", combinedArr);
    const {
    body,
    body1,
    body2,
    body3,
    body4,
    seo_description: seoDescription,
    seo_title: seoTitle,
    models_title,
  } = seriesContent || {};

  const tabButtonItems = body.find((item) => item.slice_type === "tab_buttons"); //I will use the items as the Element ID for anchor because there are different spelling of data; example: Models / Model

  const title = body[0].primary.title1 ? body[0].primary.title1 : null;
  const [tabOption, setTabOption] = useState("MAIN");
  const [activeNav, setActiveNav] = useState(0);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(
    tabButtonItems && tabButtonItems?.items[0].tab_option
  );
  const [firstTouch, setFirstTouch] = useState(null);
  const [lastTouch, setLastTouch] = useState(null);
  const modal = useRef();
  const [navbar, setNavbar] = useState(false);
  const [navbarMobile, setNavbarMobile] = useState(false);
  const { isAnnouncementBarOpen } = useContext(StorefrontContext);

  const handleNavbar = () => {
    if (global?.window.innerWidth < 1024) {
      setNavbar(false);
      if (global?.window.scrollY >= 360) {
        setNavbarMobile(true);
      } else {
        setNavbarMobile(false);
      }
    }
    if (global?.window.innerWidth >= 1024) {
      setNavbarMobile(false);
      if (global?.window.scrollY >= 510) {
        setNavbar(true);
      } else {
        setNavbar(false);
      }
    }
  };

  const sendPageView = (analyticsPageData) => {
    const payload = {
      ...getClientBrowserParameters(),
      ...analyticsPageData,
    };
    sendShopifyAnalytics({
      eventName: AnalyticsEventName.PAGE_VIEW,
      payload,
    });
  };

  const analyticsShopData = {
    shopId: "gid://shopify/Shop/63704072436",
    currency: "USD",
    acceptedLanguage: "en",
  };

  const hasUserConsent = true;

  const analytics = {
    hasUserConsent,
    ...analyticsShopData,
  };

  useEffect(() => {
    const initPixels = async () => {
      const eventId = uuidv4();
      fbEvent({
        eventName: "PageView",
        eventId: eventId,
        products: [
          {
            sku: window.location.pathname,
            quantity: 1,
          },
        ],
        enableStandardPixel: false,
      });

      // Initialize TikTok Pixel
      const options = {
        debug: false,
      };
      TiktokPixel.init(process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID, options);
      TiktokPixel.pageView();

      // Wait a bit for pixels to initialize
      await new Promise((resolve) => setTimeout(resolve, 1000));

      sendPageView(analytics);
    };

    document.body.style.overflow = isOpenMenu ? "hidden" : "unset";
    initPixels();
  }, [isOpenMenu]);

  useEffect(() => {
    window.addEventListener("scroll", handleNavbar);
    return () => window.removeEventListener("scroll", handleNavbar);
  }, []);

  // useEffect(() => {
  //   if (document.getElementById(tabOption)) {
  //     const targetEle = document.getElementById(tabOption);
  //     const pos = targetEle.style.position;
  //     const { top } = targetEle.style;
  //     targetEle.style.position = 'relative';
  //     targetEle.style.top = '-80px';
  //     targetEle.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     targetEle.style.top = top;
  //     targetEle.style.position = pos;
  //   }
  // }, [tabOption]);

  const handleActiveNav = (index) => {
    setTabOption("");
    setActiveNav(index);
    setSelectedMenu(tabButtonItems?.items[index].tab_option);
  };

  return (
    <>
      <Head>
        <link
          rel="preconnect dns-prefetch"
          href="https://triplewhale-pixel.web.app/"
          crossOrigin="true"
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://api.config-security.com/"
          crossOrigin="true"
        />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:image" content={seriesContent.og_image.url ? seriesContent.og_image.url : 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ogImage.png?v=1714058511'} />
				<meta property="og:image:type" content="image/png"/>
				<meta property="og:image:width" content="1024"/>
				<meta property="og:image:height" content="1024"/>
      </Head>
	<Script src="/tripleWhale.js" dangerouslySetInnerHTML={{ __html: 'TripleHeadless = "aftershockpcsg.myshopify.com"' }} strategy="lazyOnload" />
      <FacebookPixel />

      <div>
        <Head>
          <title>{seoTitle}</title>
          <meta name="description" content={seoDescription} />
        </Head>

        <main id="MAIN">
          <div className="content_container">
            <div className="main" id={tabButtonItems?.items[0].tab_option}>
              {body &&
                body.map((block, index) =>
                  seriesLandingSlices(block, block.slice_type, index)
                )}
            </div>

            <div
              className={`${navbar === true ? "sticky_tab" : ""}  ${
                navbarMobile === true ? "sticky_tab_mobile" : ""
              }`}
            >
              <div className="tab_menu">
                <div className="tab_container">
                  <div className="tab_button_block">
                    <h4 className="tab_title">{title}</h4>
                    <div className="tab_dropdown_menu">
                      <span
                        className="tab_text"
                        onClick={() => setIsOpenMenu((prev) => !prev)}
                      >
                        {selectedMenu}
                      </span>
                      <i className="tab_icon" />
                      {navbarMobile === true && (
                        <a
                          href={"#" + tabButtonItems?.items[0].tab_option}
                          className="buy-btn"
                        >
                          BUY
                        </a>
                      )}
                    </div>
                    <div className="tab_buttons">
                      <div className="tab_buttons_container">
                        {tabButtonItems &&
                          tabButtonItems?.items.map((item, index) => {
                            const setActiveDesktop = () => {
                              handleActiveNav(index);
                            };
                            return (
                              <div
                                className={`tab_option ${
                                  tabOption === item?.tab_option
                                    ? "active"
                                    : null
                                } `}
                                onClick={() => setTabOption(item?.tab_option)}
                                key={index}
                              >
                                <li
                                  className={
                                    activeNav === index ? "active" : ""
                                  }
                                >
                                  <Link
                                    onSetActive={setActiveDesktop}
                                    to={item.tab_option}
                                    spy
                                    smooth
                                    offset={-50}
                                    duration={1000}
                                    delay={0}
                                    onClick={() => {
                                      setIsOpenMenu(false);
                                    }}
                                  >
                                    <div
                                      className={
                                        activeNav === index ? "" : "link_text"
                                      }
                                    >
                                       {item?.tab_option}
                                    </div>
                                  </Link>
                                </li>
                              </div>
                            );
                          })}
                      </div>
                      {tabButtonItems?.primary.button_text ? (
                        <div className="configure_now_button">
                          {tabButtonItems?.primary.button_text}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div
                className="configure_tab wrapper"
                //section_id=MODELS
                style={{backgroundColor: backgroundColor ? backgroundColor : '', maxWidth: '100%'}}
              >
                <Models
                  title={models_title}
                  pcModels={combinedArr}
                  modelsCardListData={modelsCardListData}
                  primaryFontColor={primaryFontColor}
                />
              </div>
            </div>

            <div
              className="overview_tab"
              id={tabButtonItems?.items[1]?.tab_option} //section_id=OVERVIEW
            >
              {body2 &&
                body2.map((block, index) =>
                  seriesOverviewTab(block, block.slice_type, index, backgroundColor, primaryFontColor, secondaryFontColor)
                )}
            </div>

            <div
              className="gallery_tab wrapper"
              id={tabButtonItems?.items[2]?.tab_option} //section_id=GALLERY
              style={{maxWidth: '100%'}}
            >
              {body1 &&
                body1.map((block, index) =>
                  seriesGalleryTab(block, block.slice_type, index)
                )}
            </div>

            <div
              className="technical_tab wrapper"
              id={tabButtonItems?.items[3]?.tab_option} //section_id=SPECIFICATIONS
              style={{maxWidth: '100%'}}
            >
              {body4 &&
                body4.map((block, index) =>
                  seriesTechnicalTab(block, block.slice_type, index, primaryFontColor, secondaryFontColor)
                )}
            </div>

            <div
              className="video_tab wrapper"
              id={tabButtonItems?.items[4]?.tab_option} //section_id=VIDEO
            >
              {body3 &&
                body3.map((block, index) =>
                  seriesVideoTab(block, block.slice_type, index)
                )}
            </div>
          </div>
          <div
            ref={modal}
            className="menu_modal"
            onClick={(e) => {
              modal.current === e.target && setIsOpenMenu(false);
            }}
          >
            <div
              className="menu_sheet"
              onTouchStart={(e) => setFirstTouch(e.targetTouches[0].clientY)}
              onTouchMove={(e) => {
                setLastTouch(e.targetTouches[0].clientY);
              }}
              onTouchEnd={(_) =>
                firstTouch < lastTouch
                  ? setIsOpenMenu(false)
                  : setIsOpenMenu(true)
              }
              onDrag={(e) => e.clientY > 523 && setIsOpenMenu(false)}
            >
              <div className="menu_sheet_line" />
              <p className="title">{title}</p>
              <div>
                {tabButtonItems &&
                  tabButtonItems?.items.map((item, index) => {
                    const setActiveDesktop = () => {
                      handleActiveNav(index);
                    };
                    return (
                      <div
                        className={`menu_sheet_item ${
                          tabOption === item.tab_option ? "active" : null
                        } `}
                        onClick={() => setTabOption(item.tab_option)}
                        key={index}
                      >
                        <Link
                          onSetActive={setActiveDesktop}
                          to={item.tab_option}
                          spy
                          smooth
                          offset={-50}
                          duration={1000}
                          delay={0}
                          onClick={() => {
                            setIsOpenMenu(false);
                          }}
                        >
                          <li
                            className={
                              activeNav === index
                                ? "active menu_list_item"
                                : " menu_list_item"
                            }
                          >
                            <div
                              className={activeNav === index ? "" : "link_text"}
                            >
                              {item?.tab_option}
                            </div>

                            <div className="menu_icon">
                              <img src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon_right_light.png?v=1714040402" alt="menu icon" />
                            </div>
                          </li>
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </main>

        <style jsx>
          {`
            .tab_text {
              font-family: "Roboto-Medium";
              font-size: 13px;
              letter-spacing: 0;
              font-weight: 600;
            }
            .menu_modal {
              background-color: rgba(4, 4, 4, 0.5);
              position: fixed;
              left: 0;
              right: 0;
              bottom: 0;
              width: 100%;
              height: 100%;
              top: ${isOpenMenu ? "0" : "-100vh"};
              z-index: 1000;
            }
            .menu_sheet {
              background-color: #141414;
              position: fixed;
              bottom: ${isOpenMenu ? "0" : "-500px"};
              width: 100%;
              border-radius: 8px 8px 0px 0px;
              padding: 16px;
              z-index: 3;
              display: none;
              transition-property: bottom;
              transition-duration: 1s;
            }
            .menu_sheet_line {
              margin: auto;
              width: 40px;
              height: 2px;
              left: 168px;
              background: #949494;
              border-radius: 4px;
            }
            .menu_list_item {
              display: flex;
              justify-content: space-between;
            }
            .menu_list_item .link_text {
              font-size: 13px;
              font-weight: 600;
              line-height: 24px;
              letter-spacing: 0em;
              color: #e4e4e4;
            }
            .menu_sheet .title {
              margin: 26px 0px 0px 0px;
              font-family: "Roboto-Medium";
              font-size: 13px;
              font-weight: 600;
              line-height: 24px;
              letter-spacing: 0em;
              text-align: center;
              color: #949494;
              -webkit-user-select: none; /* Safari */
              -ms-user-select: none; /* IE 10 and IE 11 */
              user-select: none; /* Standard syntax */
            }
            .menu_icon {
              width: 24px;
              height: 24px;
              background-size: contain;
              background-repeat: no-repeat;
            }

            .menu_sheet_item {
              font-family: "Roboto-Medium";
              font-size: 13px;
              font-weight: 600;
              line-height: 24px;
              letter-spacing: 0em;
              -webkit-user-select: none; /* Safari */
              -ms-user-select: none; /* IE 10 and IE 11 */
              user-select: none; /* Standard syntax */
            }
            .tab_title {
              font-family: "big_noodle_titling";
              font-size: 31px;
              line-height: 40px;
              margin: 0px;
            }
            .tab_dropdown_menu {
              display: none;
              gap: 10px;
              align-items: center;
              cursor: pointer;
            }

            .tab_icon {
              width: 24px;
              height: 24px;
              background: url(${isOpenMenu
                ? "https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronUp.svg?v=1714034075"
                : "https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronDown.svg?v=1714034100"});
              background-size: contain;
              background-repeat: no-repeat;
            }
            .tab_menu {
              background: #242424;
              z-index: 3;
            }
            .tab_container {
              max-width: 1440px;
              margin: auto;
              padding: 0px 48px;
            }
            .tab_button_block {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .tab_buttons {
              height: 65px;
              display: flex;
              justify-content: center;
              algin-items: center;
              position: relative;
            }
            .tab_buttons_container {
              display: flex;
              justify-content: space-between;
              height: 65px;
              line-height: 65px;
              gap: 30px;
            }

            .tab_option {
              cursor: pointer;
              color: #949494;
              font-family: "Roboto-Medium";
              font-size: 13px;
              letter-spacing: 0;
              font-weight: 600;
              // margin-right: 30px;
              -webkit-user-select: none; /* Safari */
              -ms-user-select: none; /* IE 10 and IE 11 */
              user-select: none; /* Standard syntax */
            }
            .tab_option:hover {
              color: #e4e4e4;
            }
            .active {
              color: #fd0300;
            }
            .configure_now_button {
              height: 40px;
              width: 150px;
              background: #950810;
              border-radius: 3px;
              color: #e4e4e4;
              font-family: "Roboto-Medium";
              font-size: 13px;
              font-weight: bold;
              letter-spacing: 0;
              line-height: 40px;
              position: absolute;
              right: 60px;
              top: 13px;
              text-align: center;
            }
            .sticky_tab {
              position: sticky;
              top: 48px;
              width: 100%;
              z-index: 1;
            }
            .configure_tab {
            width: 100%;
              background-color: ${backgroundColor ? backgroundColor : ''};            
            }
            .overview_tab,
            .gallery_tab,
            .technical_tab,
            .video_tab {
              padding-top: 50px;
              margin-top: -50px;
              background-color: ${backgroundColor ? backgroundColor : ''};
            }
            .active_link {
              color: #fd0300 !important;
            }
            li {
              height: 65px;
              color: #949494;
              font-family: "Roboto-Normal";
              font-size: 13px;
              letter-spacing: 0;
              cursor: pointer;
              list-style-type: none;
            }
            li:hover {
              color: #e4e4e4;
            }
            @media (max-width: 1024px) {
              .sticky_tab_mobile {
                position: fixed;
                top: 48px;
                width: 100%;
                z-index: 3;
              }
            }
            @media (max-width: ${breakPoints.medium}) {
              .sticky_tab_mobile {
                position: fixed;
                top: ${isAnnouncementBarOpen ? "80px" : "48px"};
                width: 100%;
                z-index: 3;
              }
              .overview_tab,
              .gallery_tab,
              .technical_tab,
              .video_tab {
                padding-top: 0px;
              }
              .menu_sheet {
                display: block;
              }
              .tab_container {
                padding: 3px 16px;
              }
              .tab_title {
                font-size: 23px;
              }
              .tab_dropdown_menu {
                display: flex;
              }
              .tab_button_block {
                overflow-x: hidden;
                background: #242424;
              }
              .tab_buttons {
                // min-width: 425px;
                min-width: 550px;
                // overflow: scroll;
                display: none;
                padding-left: 30px;
                padding-right: 30px;
              }
              .configure_now_button {
                right: -280px;
              }
              .buy-btn {
                background-color: #950810;
                padding: 4px 25px 4px 25px;
                font-family: "Roboto-Medium";
                font-size: 13px;
                text-align: center;
                border-radius: 2px;
                font-weight: 600;
              }
            }
            @media (max-width: 600px) {
              .tab_menu::after {
                content: "";
                width: 60px;
                background: linear-gradient(
                  to left,
                  rgb(0 0 0),
                  rgb(0 0 0 / 2%)
                );

                position: absolute;
                right: 0;
                top: 0;
              }
            }
          `}
        </style>
      </div>
    </>
  );
};

export async function getStaticProps({ params, preview = false, previewData }) {
  const { handle } = params;
  const { ref } = previewData || {};
  const global = {};

  const seriesContent = await Prismic.getByUID(
    "series-landing-page",
    `slp-${handle}`,
    ref ? { ref } : null
  ).then((res) => res?.data || null);

  if (!seriesContent) {
    return { notFound: true };
  }

  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          global[id] = body.data;
        }
      });
    })
    .catch(() => null);

  const pcModelIds = seriesContent?.pc_models?.map(
    (model) => {
      if (!model.custom_build_pc_url.url) {
        return model.pc_model?.uid;
      }
      return model.custom_build_pc_url.url.split('?')[0].split('/').slice(-1)[0];
    }
  );

  const pcModels = await API.getPcModelBySlugs(pcModelIds);
  const modelsData = await Promise.all(
    pcModelIds.map((uid) => getDocumentByUid("pc_model", uid, ref)) // NO REDIS
  );

  const preparedModels = pcModels.map(model => {
    const temp = seriesContent.pc_models.find(item => item.pc_model.uid === model.prismic_uid);
  
    if (!temp) return model;
  
    return {
      ...model,
      ...(temp.rts_model && { rtsModel: temp.rts_model }),
      ...(temp.image_link && { customImage: temp.image_link }),
      ...(temp.redirect_link && { customLink: temp.redirect_link }),
    };
  });
  
  const prismicModels = seriesContent.pc_models.map((item) => {
    if (!item.pc_model?.id && !item.custom_build_pc_url?.url) {
      return {
        ...item,
        ...(item.rts_model && { rtsModel: item.rts_model }),
        ...(item.image_link && { customImage: item.image_link }),
        ...(item.redirect_link && { customLink: item.redirect_link }),
      };
    }
    return null;
  });

  const combinedModels = [...preparedModels, ...prismicModels].filter(Boolean);

  const modelsCardListData = modelsData.map((item) => {
    const uniqueInfoList = item?.data?.unique_info_list || [];
    return {
      uniqueInfoList: uniqueInfoList.map(info => info === undefined ? null : info),
      isShowingUniqueList: item?.data?.show_default_specs_list || false,
      isShowingThumbnailImage: item?.data?.show_thumbnail_image || false,
      isToggleComponent: item?.data?.toggle_components !== undefined ? item?.data?.toggle_components : null,
    };
  });
  

  return {
    props: {
      global,
      seriesContent,
      modelsCardListData,
      pcModels: combinedModels,
      preview,
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: [{ params: { handle: "hypergate" } }],
    fallback: true,
  };
}

export default seriesLandingPage;
